import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const FluidContainer = styled.div`
  width: 100vw;
  position: relative;
  left: ${(p) => `-${p.left}px`};
`;

const withFluidContainer = (Component) => (props) => {
  const [mounted, setMounted] = useState(false);
  const [left, setLeft] = useState();

  const ref = useRef();

  const getLeft = () => {
    if (ref.current) {
      return ref.current.getBoundingClientRect().left;
    }
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      setLeft(getLeft());
    });

    setLeft(getLeft());
    setMounted(true);
  }, []);

  return (
    <>
      <div ref={ref} />
      {mounted && (
        <FluidContainer left={left}>
          <Component {...props} />
        </FluidContainer>
      )}
    </>
  );
};

export default withFluidContainer;
